import ProductBouquetPresenter from "@adapters/features/Markets/OTC/Presenters/ProductBouquet";
import TransactionJourneyPresenter from "@adapters/features/Markets/OTC/Presenters/TransactionJourney";
import OrderBookPresenter from "@adapters/features/Markets/OTC/Presenters/OrderBook";
import LeadServicePresenter from "@adapters/features/Markets/OTC/Presenters/RegisterLeadService";
export default (function (useCases, actions) {
    return {
        proproductBouquet: new ProductBouquetPresenter(useCases.productBouquet, actions),
        transactionJourney: new TransactionJourneyPresenter(useCases.transactionJourney, actions),
        orderBook: new OrderBookPresenter(useCases.orderBook, actions),
        registerLead: new LeadServicePresenter(useCases.registerLead, actions),
    };
});
